<template>
  <v-dialog v-model="dialog_loading" max-width="290">
    <v-card>
      <v-card-title class="primary white--text">Loading</v-card-title>
      <v-card-text>
        <v-progress-linear indeterminate></v-progress-linear>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'DialogLoading',
  props: ['visible'],
  computed: {
    dialog_loading: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit('close');
        }
      }
    }
  }
};
</script>